import { render, staticRenderFns } from "./appFormList.vue?vue&type=template&id=f896ed5c"
import script from "../../controllers/application_form/app-form-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/application_form/app-form-list.js?vue&type=script&lang=js&external"
import style0 from "./appFormList.vue?vue&type=style&index=0&id=f896ed5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports